import { PracticeFrontAccessPointStage} from "../apisAccessPoint";
import {practiceFrontHttpClient} from "../practiceFrontRootHttpClient";

export const getPracticeFrontByDomain= async (id:string): Promise<any> => {
    return practiceFrontHttpClient.then(({ get }) => get(`/public/v1/practice-front/${id}`));
};
export const getPracticeFrontByDomainStage= async (id:string): Promise<any> => {
    return practiceFrontHttpClient.then(({ get }) => get(`${PracticeFrontAccessPointStage}/public/v1/practice-front/${id}`));
};

